import React from "react";

export const Team = (props) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Meet the Team</h2>
          <p>
            We are a team of seasoned AI experts and data scientists who have been innovating with artificial intelligence and machine learning long before it became the industry buzzword it is today. With a wealth of experience across industries—from healthcare to aerospace—we have consistently delivered high-impact AI solutions that meet and exceed our clients' expectations.<br /><br />
            Our track record speaks for itself:<br />
            • Dynamic Pricing in Retail: We helped businesses optimize pricing strategies in real-time, boosting profits and customer satisfaction.<br />
            • Document Automation in Legal Services: Our NLP systems have saved clients countless hours by automating document review and summarization.<br />
            • Predictive Models in Healthcare: We developed AI models with above 90% accuracy to predict cardiovascular health risks, improving patient care.<br />
            • Route Optimization in Transport: We enabled logistics companies to cut costs and streamline operations with machine learning-driven route optimization.<br /><br />
            From problem discovery to solution delivery, we’re dedicated to pushing the boundaries of what's possible with AI.
          </p>
        </div>
        <div id="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-3 col-sm-6 team">
                  <div className="thumbnail">
                    <img src={d.img} alt="..." className="team-img" />
                    <div className="caption">
                      {/* Conditionally render link if LinkedIn exists */}
                      <h4>
                        {d.LinkedIn ? (
                          <a href={d.LinkedIn} target="_blank" rel="noopener noreferrer">
                            {d.name}
                          </a>
                        ) : (
                          d.name
                        )}
                      </h4>
                      <p>{d.job}</p>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
